export default __webpack_public_path__ + "static/media/icon-back-button.69980891.svg";